import React from "react";
import Layout from "../Layout";
import Form from "./reserveForm";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import dayjs from "dayjs";
dayjs.locale("ja");

function Users(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);
  const reserveId = parseInt(params.reserveId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [plan, setPlan] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - プラン変更予約" + (reserveId === 0 ? "登録" : "更新");
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchData();
  }, [auth.state.token]);

  const fetchData = () => {
    // 変更予約が無い場合はアカウント情報に紐づく情報を取得
    if (reserveId === 0) {
      request({
        method: "GET",
        url: `admin/accounts/${accountId}`,
      }).then((result) => {
        const initPlan = {
          validFrom: dayjs().add(1, "day").format("YYYY-MM-DD 00:00:00"),
          contractType: result.data.data.contract_type,
          fhUser: result.data.data.fh_user,
          fhPassword: result.data.data.fh_password,
          maxWords: result.data.data.max_words,
          maxTweets: result.data.data.max_tweets,
          maxCurrent: result.data.data.max_current,
        }
        setPlan(initPlan);      
      });
    } else {
      request({
        method: "GET",
        url: `admin/reservations/${accountId}/${reserveId}`,
      }).then((result) => {
        console.log(result);
        const initPlan = {
          validFrom: result.data.data.valid_from,
          contractType: result.data.data.contract_type,
          fhUser: result.data.data.fh_user,
          fhPassword: result.data.data.fh_password,
          maxWords: result.data.data.max_words,
          maxTweets: result.data.data.max_tweets,
          maxCurrent: result.data.data.max_current,
        }
        setPlan(initPlan);      
      });
    }
  }

  const handleSubmit = (plan) => {
    if (reserveId === 0) {
      // プラン変更予約登録
      request({
        method: "POST",
        url: `admin/reservations/${accountId}`,
        data: {
          contract_type: plan.contractType,
          max_tweets: plan.maxTweets,
          max_current: plan.maxCurrent,
          fh_user: plan.fhUser,
          fh_password: plan.fhPassword,
          max_words: plan.maxWords,
          valid_from: plan.validFrom,
        },
      }).then((result) => {
        stateError.initialize();
        props.history.push("/admin/account?success=create");
      }).catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
    } else {
      // プラン変更予約更新
      request({
        method: "PUT",
        url: `admin/reservations/${accountId}/${reserveId}`,
        data: {
          contract_type: plan.contractType,
          max_tweets: plan.maxTweets,
          max_current: plan.maxCurrent,
          fh_user: plan.fhUser,
          fh_password: plan.fhPassword,
          max_words: plan.maxWords,
          valid_from: plan.validFrom,
        },
      }).then((result) => {
        stateError.initialize();
        props.history.push("/admin/account?success=edit");
      }).catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
    }
  };

  const deleteReserve = () => {
    request({
      method: "DELETE",
      url: `admin/reservations/${accountId}/${reserveId}`,
    })
      .then((result) => {
        stateError.initialize();
        props.history.push("/admin/account?success=delete");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          plan={plan}
          submit={handleSubmit}
          deleteReserve={deleteReserve}
          isEdit={reserveId === 0 ? false : true}
        />
      }
    />
  );
}
export default withRouter(Users);
